export const environment = {
  production: false,
  appDomain: 'https://afrogift.com',
  api: 'https://afrogift.com/api',
  pub_key: "7f2G4iAwNUrJcGe05gNUrJBYZjsGkcAY0LWp9ck0826oA0826wNUrJcAf2G2G4iAnrY0LWp9n",
  paystack: "",
  afro: 'https://ag.rarebreedmentribe.org.uk',
  tawkexternal: "",
  wallet: "",
  serverAddress: '100.85.124.80',
  ipApi: 'https://ipapi.co/json/',
  infurakey: "",
  partnerConnect: 'https://100.85.124.80:1967',
  adminAddress: 'somtobuchi@gmail.com',
  authUrl: 'https://100.85.124.80:1959',

  // Add the missing properties here:
  authApi: 'your-auth-api-key', // This is for the auth component
  blogDomain: 'https://afrogift.hashnode.dev/', // Update with actual blog URL
  devDomain: 'https://developer.afrogift.com.ng/hire', // Update with actual blog URL
  cyberDomain: 'https://cyberroom.afrogift.com.ng/uzor', // Update with actual blog URL
  donationDomain: 'https://donation.afrogift.com/official', // Update with actual donation URL
  employmentDomain: 'https://your-employment-domain.com' // Update with actual employment URL
};
